// extracted by mini-css-extract-plugin
export default {"wrapper":"Offers_wrapper__lBOTb","Offers":"Offers_Offers__pq5le","wrapper_card":"Offers_wrapper_card__+XK6T","title":"Offers_title__aUPFz"};